import { TranslateFunction } from '~/Locale';

export const getRegistrationTitle = (
  isCompany: boolean,
  t: TranslateFunction
) =>
  isCompany ? t('Register a free company account') : t('Register an account');
